/** Default remarks pre-filled on new EI receipt forms */
export const DEFAULT_EI_REMARKS = [
  'TANK PRESSURED WITH 0.5 BAR NITROGEN. LEAK TEST DONE AT 1 BAR AND FOUND SATISFACTORY.',
  'STEAM LINE HAVE NO FOREIGN MATERIAL.',
];

export const DEFAULT_INTERNAL_REMARKS = {
  non_transferable_cargo_stains: '',
  polish_buffing_marks: '',
  additional_remarks: [],
};

/** Default general condition for new EI receipts (all YES). */
export const DEFAULT_GENERAL_CONDITION = {
  frame_tank_walkways_free: 'YES',
  manlid_valve_compartments_free: 'YES',
  serial_numbers_legible: 'YES',
  unit_having_steam_jacket: 'YES',
  unit_having_bottom_seal: 'YES',
  unit_having_gasket_on_manlid: 'YES',
  dipstick_originally_fitted: 'YES',
  calibration_chart_fitted: 'YES',
  siphon_tube_originally_fitted: 'YES',
  no_cuts_on_ladder_and_walkway: 'YES',
  pressure_gauge_fitted: 'YES',
  temperature_gauge_fitted: 'YES',
  prv_with_poppet: 'YES',
  top_discharge_provision: 'YES',
  rfid_gps_unit: 'YES',
  interior_clean_dry_and_odourless: 'YES',
  valves_fittings_free_from_previous_cargo: 'YES',
  walk_way_type: '',
};

/**
 * Normalize internal_remarks and include any text still in the "add" input
 * (user may submit without clicking Add).
 */
export const finalizeInternalRemarksForSubmit = (internalRemarks, pendingAdditionalText = '') => {
  const normalized = normalizeInternalRemarks(internalRemarks);
  const pending = String(pendingAdditionalText || '').trim();
  if (pending) {
    normalized.additional_remarks = [...normalized.additional_remarks, pending];
  }
  return normalized;
};

/** Normalize internal_remarks from API (handles legacy array/empty values). */
export const normalizeInternalRemarks = (data) => {
  if (!data || Array.isArray(data) || typeof data !== 'object') {
    return { ...DEFAULT_INTERNAL_REMARKS, additional_remarks: [] };
  }

  const additional = Array.isArray(data.additional_remarks)
    ? data.additional_remarks
    : [];

  return {
    non_transferable_cargo_stains: data.non_transferable_cargo_stains || '',
    polish_buffing_marks: data.polish_buffing_marks || '',
    additional_remarks: additional.filter((r) => r && String(r).trim()),
  };
};
